import { SVGProps } from 'react';

const SvgDepression = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <g clipPath="url(#Depression_svg__a)">
      <path
        fill="#FC3"
        d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z"
      />
      <path
        fill="#FFD45C"
        d="M17.952 20.008a.935.935 0 1 0-.908-1.636c-2.232 1.24-5.064 2.988-7.132 5.544A13.818 13.818 0 0 0 7.508 28.3c-.112.348-.208.704-.296 1.064.544.356 1.108.684 1.696.972.992-5.144 4.868-8.02 9.044-10.336v.008Z"
      />
      <path
        fill="#FFDE83"
        d="M17.144 24.708a.935.935 0 0 0-.78-1.7c-2.912 1.332-5.24 4.476-6.02 7.96.584.22 1.18.408 1.792.56.264-1.272.78-2.532 1.5-3.64.936-1.444 2.18-2.572 3.504-3.18h.004Z"
      />
      <path
        fill="#FB3"
        d="M28.196 12.3c-2.436-1.496-5.508-2.004-8.892-1.476-2.328.364-5.252 1.412-7.828 2.804-2.288 1.236-5.416 3.344-7.336 6.388a.934.934 0 1 0 1.58.996c2.98-4.72 9.908-7.72 13.872-8.34 2.98-.468 5.544-.056 7.624 1.22 2.008 1.236 3.46 3.224 4.324 5.904.28-1.144.432-2.336.452-3.56-.984-1.66-2.264-2.992-3.796-3.936Z"
      />
      <path
        fill="#FFE9AB"
        d="M5.656 28.204a13.3 13.3 0 0 1 .724-1.84c1.272-2.652 3.448-5.052 6.652-7.332 3.22-2.292 7.968-4.008 11.316-2.668 2.164.864 3.576 2.924 4.196 6.116.156.808-.12 1.58-.76 2.124-.684.58-1.632.768-2.412.48-.984-.364-1.664-1.448-1.916-3.052a.932.932 0 0 0-1.068-.776.932.932 0 0 0-.776 1.068c.488 3.104 2.16 4.16 3.112 4.516 1.028.38 2.16.32 3.168-.12a16.012 16.012 0 0 0 2.56-3.828c0-.252-.02-.508-.068-.764-.748-3.86-2.544-6.38-5.336-7.496-4.28-1.708-9.728.484-13.096 2.88-3.468 2.468-5.84 5.1-7.252 8.048-.192.404-.364.812-.52 1.224.46.508.96.98 1.48 1.424l-.004-.004ZM8.62 11.228a.935.935 0 1 0 .984 1.592C15.14 9.404 19.332 9 22.364 9.028c4.5.044 7.52 2.156 9.4 4.22a15.845 15.845 0 0 0-.976-3.368c-2.428-1.756-5.292-2.692-8.408-2.72-3.284-.028-7.816.404-13.76 4.068Z"
      />
      <path
        fill="#FFE9AB"
        d="M18.224 27.072a.936.936 0 0 0-1.796.524 8.072 8.072 0 0 0 2.716 4.096 15.824 15.824 0 0 0 2.376-.668c-1.216-.624-2.668-1.796-3.296-3.948v-.004Z"
      />
      <path
        fill="#FFDE83"
        d="M21.608 26.212c-1.544-2.468-1.72-4.176-.592-5.712.54-.736 1.392-1.096 2.168-.916 1.012.232 1.76 1.316 2.06 2.972a.937.937 0 0 0 1.084.756.937.937 0 0 0 .756-1.084c-.436-2.424-1.704-4.052-3.476-4.464-1.504-.348-3.112.292-4.096 1.632-2.112 2.88-.72 5.836.512 7.808a6.984 6.984 0 0 0 3.62 2.856c.82-.448 1.596-.968 2.32-1.544-2.012.164-3.656-1.18-4.36-2.304h.004ZM13.952 5.24a.935.935 0 0 0 .596 1.772c4.14-1.384 7.936-1.74 11.288-1.06 1.212.248 2.368.636 3.468 1.152a16.26 16.26 0 0 0-2.408-2.824c-.228-.056-.456-.116-.684-.164-3.676-.748-7.8-.372-12.256 1.116l-.004.008Z"
      />
      <path
        fill="#FB3"
        d="M15.368 29.828a.937.937 0 0 0-1.24.46 6.957 6.957 0 0 0-.5 1.536c.616.092 1.244.144 1.88.164.076-.308.18-.616.32-.92a.937.937 0 0 0-.46-1.24Z"
      />
    </g>
    <defs>
      <clipPath id="Depression_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDepression;
